var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-box"},[_c('img',{staticClass:"mb-4",attrs:{"src":require('../../assets/logo-ev-tools.png'),"width":"160"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }